import Image from "~/components/ui/Image";
import { ProductLeaf } from "@decocms/apps-commerce/types";
import { sanitizeStoreUrl } from "~/utils/constants";

interface Props {
  variant?: "disabled" | "default";
  isSelected: boolean;
  showImage?: boolean;
  mainImage?: string;
  productVariants?: ProductLeaf[];
  link?: string;
  content: string;
  /** @description Tamanho do círculo quando não há imagem (ex: botão de tamanho). "lg" usado na PDP pra bater com o alvo de toque mínimo recomendado (44px); o padrão ("sm", 32px) é o usado nos cards de vitrine/PLP. */
  size?: "sm" | "lg";
}

const withImageVariants = {
  disabled:
    `border border-[#C9C9C9] hover:border-primary opacity-40 font-['Poppins']`,
  default: "border border-[#C9C9C9] hover:border-primary font-['Poppins']",
};

const withImageSelected =
  "ring ring-[#333333] ring-offset-base-100 ring-offset-2 !opacity-100";

const withoutImageVariants = {
  disabled:
    `text-[#646467]/25 border border-[#C9C9C9] font-['Poppins'] after:absolute after:left-0 after:top-1/2 after:h-[1px] after:bg-[#C9C9C9] after:w-full after:block after:-rotate-45 after:content-[""]`,
  default:
    "text-[#646467] border border-[#C9C9C9] font-['Poppins'] hover:border-primary",
};

const withoutImageSelected = "bg-[#333333] text-white";

function Avatar({
  content,
  showImage,
  mainImage,
  productVariants,
  link,
  isSelected,
  variant = "default",
  size = "sm",
}: Props) {
  if (showImage && productVariants?.length === 0) {
    return (
      <div className="avatar">
        <div
          className={`rounded-full w-11 h-11 ${
            withImageVariants[variant]
          } ${isSelected && withImageSelected}}`}
        >
          <Image
            loading="lazy"
            fetchPriority="low"
            decoding="async"
            src={mainImage ?? ""}
            width={44}
            height={44}
            alt={content}
          />
        </div>
      </div>
    );
  }

  const productVariant = productVariants?.find(
    (variant) => sanitizeStoreUrl(variant.url) === link,
  );

  const variantImages = productVariant?.image;

  if (showImage && variantImages) {
    return (
      <div className="avatar">
        <div
          className={`rounded-full w-11 h-11 ${
            withImageVariants[variant]
          } ${isSelected && withImageSelected}`}
        >
          <Image
            loading="lazy"
            fetchPriority="low"
            decoding="async"
            src={variantImages[0].url ?? ""}
            width={44}
            height={44}
            alt={content}
          />
        </div>
      </div>
    );
  }

  const sizeClass = size === "lg" ? "w-11 h-11" : "w-[32px] h-[32px]";

  return (
    <div className="avatar avatar-placeholder text-xs">
      <div
        className={`rounded-full ${sizeClass} ${
          withoutImageVariants[variant]
        } ${isSelected && withoutImageSelected}`}
      >
        <span className="uppercase text-xs">{content.substring(0, 2)}</span>
      </div>
    </div>
  );
}

export default Avatar;
